import { createAction, props } from '@ngrx/store';
import { ServiceNotificationItem } from './service-notifications.models';

export const loadServiceNotifications = createAction(
  '[ServiceNotifications] Load Notifications'
);

export const loadServiceNotificationsSuccess = createAction(
  '[ServiceNotifications] Load Notifications Success',
  props<{ notifications: ServiceNotificationItem[] }>()
);

export const loadServiceNotificationsFailure = createAction(
  '[ServiceNotifications] Load Notifications Failure',
  props<{ error: string }>()
);

export const markServiceNotificationAsRead = createAction(
  '[ServiceNotifications] Mark Notification As Read',
  props<{ id: string }>()
);

export const patchServiceNotifications = createAction(
  '[ServiceNotifications] Patch Notifications',
  props<{ updates: { id: string; read: boolean }[]; retry?: boolean }>()
);

export const patchServiceNotificationsSuccess = createAction(
  '[ServiceNotifications] Patch Notifications Success',
  props<{ updates: { id: string; read: boolean }[] }>()
);

export const patchServiceNotificationsFailure = createAction(
  '[ServiceNotifications] Patch Notifications Failure',
  props<{ error: string; updates: { id: string; read: boolean }[]; retry?: boolean }>()
);

